import React from "react";
import styles from "./box.module.scss";
import GET_SUPPORT from '../../../assets/GET SUPPORT.jpg'
import GET_SUPPORT_2 from '../../../assets/GET SUPPORT_2'
import HAPPY_CUSTOMER from '../../../assets/HAPPY_CUSTOMER.jpg'
import millensys_support_client from '../../../assets/PDF/millensys_support_client.zip'
import { Link } from "react-router-dom";
import { BiSupport } from "react-icons/bi";
import { FaPhoneAlt } from "react-icons/fa";


const Box = () => {
  return (
    <section className={styles.box_container}>
      <div className={styles.___container}>
        {/* Box 1  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={GET_SUPPORT} alt='GET SUPPORT' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              <BiSupport /> | Welcome to MILLENSYS Customer Support
              </Link>
              <strong className={styles.__strong}>
              Support Team is always available for our customer requests.
              </strong>
              <p className={styles.__content}>
              MILLENSYS support is well known by its customer care professionalism. Fast and accurate support makes our customers work safely
              and get the maximum of their MILLENSYS products. Millensys deep believe in customer support is keeping our support department working day by day to improve the up-time of our products
              on customer side by applying periodical preventive maintenance, continuing training and after sale support to our customers.
              </p>
                <FaPhoneAlt className={`${styles.icon} fs-5`} />
                <span className={styles._contact} >Hotline | +201117000311</span>
                <a href="mailto:support@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>Support | support@millensys.com</a>
                <a href="mailto:gulf.support@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>Gulf area | gulf.support@millensys.com</a>
                <a href="mailto:americas.support@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>North and South America | americas.support@millensys.com</a>
            </div>
          </div>
        </div>

        {/* Box 2  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Remote Support
              </Link>
              <strong className={styles.__strong}>
              Any-time | Any-where
              </strong>
              <p className={styles.__content}>
                Monitoring online our installations around the globe to insure maximum performance and quick online service to our customers.
                by using the remote service, both of our partners and customers can have support on the fly and reduce the cost of having on-site personnel.
                Getting direct support from the vendor "MILLENSYS" insure maximum quality of service provided to the end user.
                Also Remote support program can help in online training's and demonstrations
              </p>
              <button className={styles["product___btn"]}>
                <a href={millensys_support_client} download>To get support , you need to download and install a small remote support application and connect your licensed application to the internet.</a>
              </button>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={GET_SUPPORT_2} alt='MILLENSYS-GET_SUPPORT' loading="lazy"/>
              </div>
            </div>
          </div>
        </div>

        {/* Box 3  */}
        <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={HAPPY_CUSTOMER} alt='HAPPY CUSTOMER' loading="lazy"/>
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <Link to='#' className={styles._headding}>
              Customer Loyalty
              </Link>
              <strong className={styles.__strong}>
              Targeting maximum customer satisfaction
              </strong>
              <p className={styles.__content}>
                As our customer base is growing yearly and in different markets, MILLENSYS has unified the use of a CRM application developed based on the
                MiERP application solution and is continuously measuring it customer satisfaction and providing a pro-active support techniques to prevent
                problems from happening and given early warning to our customers about the status of their solution
                i.e. aiming to maximize customer satisfaction and retain more loyal customers.
              </p>
            </div>
          </div>
        </div>

        {/* Box 3  */}
        {/* <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={analog_horizon} alt='analog horizon' />
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <h2 className={styles._headding2}>Analog</h2>
              <strong className={styles.__strong}>
                Fully Featured. Economical Price.
              </strong>
              <p className={styles.__content}>
                The Analog carestream Systems have just the right configuration
                to meet your most pressing needs in the present, with a clear
                upgrade path for the future. All at a surprisingly affordable
                price.
              </p>

              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Horizon X-ray System
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div> */}

        {/* Box 4  */}
        {/* <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <h2 className={styles._headding2}>Software</h2>
              <strong className={styles.__strong}>Powered by Eclipse.</strong>
              <p className={styles.__content}>
                Eclipse is the engine that drives carestream’s CR and DR imaging
                software. Eclipse uses AI technology and proprietary algorithms
                to significantly increase the value of the entire imaging chain,
                from capture to diagnosis.
              </p>

              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    ImageView Software
                  </Link>
                </li>

                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Image Suite Software
                  </Link>
                </li>

                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    DIRECTVIEW Software
                  </Link>
                </li>
              </ul>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={medicalsoftware} alt='medical software' />
              </div>
            </div>
          </div>
        </div> */}

        {/* Box 5  */}
        {/* <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={medicalprinting} alt='medical printing' />
              </div>
            </div>
            <div className={styles.__box_rightside}>
              <h2 className={styles._headding2}>Printing Systems</h2>
              <strong className={styles.__strong}>
                Options for Printing Excellence.
              </strong>
              <p className={styles.__content}>
                carestream’s DRYVIEW Laser Imaging Systems offer a complete
                diagnostic imaging portfolio. Our systems make it easy and
                affordable to meet your needs today and tomorrow.
              </p>

              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    DRYVIEW Laser Imagers and DRYVIEW Film Products
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div> */}

        {/* Box 4  */}
        {/* <div className={styles.__box}>
          <div className={styles.__box_main}>
            <div className={styles.__box_rightside}>
              <h2 className={styles._headding2}>Dental</h2>
              <strong className={styles.__strong}>
                A Century of Leadership.
              </strong>
              <p className={styles.__content}>
                For over 100 years, we’ve provided industry-leading solutions
                for dental professionals. With carestream Dental Film, you can
                be confident in superb intraoral and extraoral diagnostic images
                quickly, easily and reliably.
              </p>

              <ul className={styles.__bullets}>
                <li>
                  <Link to='#' className={styles.__bullet}>
                    <GoDotFill className={styles.__bullet_dot} />
                    Dental
                  </Link>
                </li>
              </ul>
            </div>

            <div className={styles.__box_leftside}>
              <div className={styles.__box_image}>
                <img src={medicaldental} alt='medical dental' />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Box;
